import { IoCalendarOutline } from 'react-icons/io5'
import { vccBtn } from '@shared/ui/vccButtons'
import { vccButtonLabel, type VccActionButtonProps } from './vccButtonProps'

export type UploadButtonProps = VccActionButtonProps

export default function UploadButton({
  onClick,
  disabled,
  type = 'button',
  className = '',
  showIcon = true,
  loading = false,
  loadingLabel = 'Starting...',
  label = 'Upload',
  children,
  ...rest
}: UploadButtonProps) {
  return (
    <button
      type={type}
      className={`${vccBtn('execute')} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled || loading}
      {...rest}
    >
      {showIcon && !loading && <IoCalendarOutline aria-hidden className="vcc-btn__icon" />}
      {vccButtonLabel({ children, label, loading, loadingLabel }, label)}
    </button>
  )
}
